import React, { Component } from "react";
import StepperPage from "./StepperPage";
import { withStyles } from "@material-ui/core/styles";
import { Trans } from "react-i18next";
import AdvancedSharepointSettings from "../settings/advanced/AdvancedSharepointSettings";
import AdvancedDriveSettings from "../settings/advanced/AdvancedDriveSettings";
import AdvancedDropboxSettings from "../settings/advanced/AdvancedDropboxSettings";
import AdvancedWebsiteSettings from "../settings/advanced/AdvancedWebsiteSettings";
import AdvancedCommonFileSettings from "../settings/advanced/AdvancedCommonFileSettings";
import Typography from "@material-ui/core/Typography";

const styles = (theme) => ({
  advancedPage: {
    display: "flex",
  },
  filterContainer: {
    flex: 1,
  },
});
export class AdvancedSettings extends Component {
  state = {
    presentationProperties: {},
    readerProperties: {},
    reindexerProperties: {},
    sourceProperties: {},
    spiderProperties: {},
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.state !== prevState) {
      this.settingsUpdated();
    }
  }

  render() {
    return (
      <>
        <Typography variant="h5">
          <Trans i18nKey="create_ks_advanced_filters" />
        </Typography>
        <Typography variant="body2" gutterBottom>
          <Trans i18nKey="create_ks_advanced_filters_subheader" />
        </Typography>
        {this.props.sourceType === "SHAREPOINT" || this.props.sourceType === "ONEDRIVE" && (
          <AdvancedSharepointSettings
            editKs={this.props.editKs}
            updateURL={this.updateURL}
            setSpiderProperties={this.setChildSpiderProperties}
            setSourceProperties={this.setChildSourceProperties}
            setReaderProperties={this.setChildReaderProperties}
          />
        )}
        {this.props.sourceType === "GOOGLE_DRIVE" && (
          <AdvancedDriveSettings
            setSpiderProperties={this.setChildSpiderProperties}
            setSourceProperties={this.setChildSourceProperties}
            setReaderProperties={this.setChildReaderProperties}
            editKs={this.props.editKs}
          />
        )}
        {this.props.sourceType === "DROPBOX" && (
          <AdvancedDropboxSettings
            setSpiderProperties={this.setChildSpiderProperties}
            setSourceProperties={this.setChildSourceProperties}
            setReaderProperties={this.setChildReaderProperties}
            editKs={this.props.editKs}
          />
        )}
        {this.props.sourceType === "WEBSITE" && (
          <AdvancedWebsiteSettings
            setSpiderProperties={this.setChildSpiderProperties}
            setSourceProperties={this.setChildSourceProperties}
            setReaderProperties={this.setChildReaderProperties}
            editKs={this.props.editKs}
          />
        )}
        {this.props.sourceType === "FILE_SHARE" && (
          <AdvancedCommonFileSettings
            setSpiderProperties={this.setChildSpiderProperties}
            setSourceProperties={this.setChildSourceProperties}
            setReaderProperties={this.setChildReaderProperties}
            editKs={this.props.editKs}
          />
        )}
      </>
    );
  }

  settingsUpdated = () => {
    this.props.setSpiderProperties(this.state.spiderProperties);
    this.props.setSourceProperties(this.state.sourceProperties);
    this.props.setReaderProperties(this.state.readerProperties);
  };

  setChildSpiderProperties = (spiderProperties) => {
    this.setState({
      spiderProperties,
    });
  };
  setChildSourceProperties = (sourceProperties) => {
    this.setState({
      sourceProperties,
    });
  };
  setChildReaderProperties = (readerProperties) => {
    this.setState({
      readerProperties,
    });
  };
}

export default StepperPage(withStyles(styles)(AdvancedSettings));
